import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullRegion from "../../services/fragments/fullRegion"

const listRegionsQuery = gql`
  query Regions($limit: Int, $cursor: String, $ids: [String!], $state: RegionActiveState) {
    regions(limit: $limit, cursor: $cursor, ids: $ids, state: $state) {
      results {
        ...fullRegion
      }
      cursor
      hasMore
      total
    }
  }
  ${fullRegion}
`

export const regionsKey = getQueryNames(listRegionsQuery)[0]

export default listRegionsQuery
